<template>
  <div class="report-item editor-component" :style="themeStyle">
    <div class="wrapper">
      <div v-if="config.image" class="result-image">
        <img :src="config.image" />
      </div>
      <div class="result-text">
        <transition v-on:before-appear="beforeEnter" name="fade" appear>
          <div class="loading-result" v-show="loadingResult">
            <div class="loader"></div>
            <p>Calculating...</p>
          </div>
        </transition>
        <transition name="fade" appear>
          <Layout
            v-if="!loadingResult"
            @ready="onLayoutReady"
            :editable="editable"
            :key="layoutKey"
            :config="config"
            data-appear="2000"
          ></Layout>
        </transition>
        <CCFooter v-if="shouldShowFooterElements" ref="footer"></CCFooter>
      </div>
    </div>
    <PoweredBy v-if="shouldShowFooterElements"></PoweredBy>
  </div>
</template>
<script>
import Velocity from "velocity-animate";
import Utilities from "../lib/Utilities";
import CCFooter from "./CCFooter";
import Layout from "./layout/Layout.vue";
import PoweredBy from "./PoweredBy";
export default {
  props: {
    config: {
      default: () => {
        {
        }
      },
      type: Object
    },
    editable: { default: true, type: Boolean },
    theme: {
      type: Object,
      default: () => {
        {
        }
      }
    },
    actions: {
      type: Array,
      default: () => {
        [];
      }
    }
  },
  provide() {
    return {
      editable: this.editable
    };
  },
  components: {
    Layout,
    PoweredBy,
    CCFooter
  },
  created() {
    this.content = this.config;
  },
  mounted() {
    setTimeout(() => {
      this.loadingResult = false;
    }, 2000);
  },
  data() {
    return {
      content: {},
      layoutReady: false,
      loadingResult: true
    };
  },
  computed: {
    shouldShowFooterElements() {
      return this.$store.getters.isResultPage && this.layoutReady;
    },
    layoutKey() {
      return Utilities.key();
    },
    themeStyle() {
      return {
        backgroundColor: this.content.backgroundColor,
        color: this.content.textColor
      };
    },
    titleSize() {
      return this.content.titleFontSize || 100;
    },
    textSize() {
      return this.content.textFontSize || 100;
    }
  },
  methods: {
    beforeEnter: function(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "100%", translateZ: 0 },
        { duration: 0 }
      );
      const delay = Number(el.dataset.appear);
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: "0%", translateZ: 0 },
          { complete: done, duration: 500 }
        );
      }, delay);
    },
    onLayoutReady() {
      this.layoutReady = true;
    },
    onDelete() {
      this.$emit("delete");
    },
    onEdit() {
      let editable = [
        {
          name: "backgroundcolor",
          label: "Background Color",
          type: "color",
          model: "backgroundColor"
        },
        {
          name: "color",
          label: "Text Color",
          type: "color",
          model: "textColor"
        }
      ];
      let fields = [
        {
          title: "Colours",
          classes: "grid colours",
          fields: editable
        },
        {
          title: "Fonts",
          classes: "grid colours",
          fields: [
            {
              name: "titleFontSize",
              label: "Title font size",
              type: "number",
              model: "titleFontSize"
            },
            {
              name: "textFontSize",
              label: "Text font size",
              type: "number",
              model: "textFontSize"
            }
          ]
        }
      ];
      this.$emit("edit", {
        target: this.content,
        fields: fields,
        editorConfig: { title: "Layout" }
      });
    },
    onAdd() {
      this.$emit("add");
    },
    updateText(field, event) {
      this.content[field] = event.value;
    }
  }
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.loading-result {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  margin: auto;
  background-color: #040A4E;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.loader {
  margin: 0 auto;
  width: 15px;
  aspect-ratio: 1;
  position: relative;
}
.loader::before,
.loader::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: #ea597b;
}
.loader::before {
  box-shadow: -25px 0;
  animation: l8-1 1s infinite linear;
}
.loader::after {
  transform: rotate(0deg) translateX(25px);
  animation: l8-2 1s infinite linear;
}
@keyframes l8-1 {
    100%{transform: translateX(25px)}
}
@keyframes l8-2 {
    100%{transform: rotate(-180deg) translateX(25px)}
}
</style>
